import { MerchantOrder } from "src/app/_entities/merchant-order/merchant-order.modal";
import IEntityChange from "src/app/_interfaces/i-entity-change";
import { DateRange, OrdersFiltersModel } from "src/app/_models/self-ship/orders/orders-filters.model";


export class LoadOrders {
    static readonly type = '[Orders] Load Orders';
    constructor(public reload: boolean = false) { }
}

export class LoadOrderCounts {
    static readonly type = '[Orders] Load Order counts';
    constructor(public loadOrder: boolean = true) { }
}

export class UpdateOrdersFilters {
    static readonly type = '[Orders] Update Filters';
    constructor(public filters: Partial<OrdersFiltersModel>) { }
}

export class UpdateDateRange {
    static readonly type = '[Orders] Update Date Range';
    constructor(public dateRange: DateRange) { }
}

export class SyncOrder {
    static readonly type = '[Orders] Sync Order';
    constructor(public notification: IEntityChange<MerchantOrder>) { }
}

export class SyncOrders {
    static readonly type = '[Orders] Sync Orders';
    constructor(public notifications: IEntityChange<MerchantOrder>[]) { }
}

